<template>
	<pre v-html="$t('terms.legal_indication2')"></pre>
</template>

<script>
export default {
	name: 'LegalIndication2',
};
</script>

<style scoped></style>
